<template>
  <div
    class="row bg-white q-px-md q-py-sm tw-rounded-xl tw-border tw-border-solid tw-border-line tw-shadow-[0_10px_24px_-14px_rgba(23,105,182,0.4)]"
    style="position: relative"
  >
    <div
      v-if="isLoading"
      class="flex col items-center justify-center q-my-lg"
    >
      <q-spinner-ios
        color="primary"
        size="3em"
      />
    </div>

    <div
      v-else
      class="col-auto"
    >
      <DetailsProgress
        v-if="!isLoading && call"
        :status="call.status"
        :reason="call.reason"
        :history="call.history"
        :direction="call.direction"
        :agent-name="call.agentName"
        :position="call.initialPosition"
        :tags="call.tags"
      />
    </div>
  </div>
</template>

<script>
import DetailsProgress from '@/components/DetailsProgress'

export default {
  components: {
    DetailsProgress
  },

  props: {
    phone: {},
    callId: {},
    queueId: {},
    agentId: {},
    createdAt: {},
    direction: {}
  },

  data () {
    return {
      isLoading: true,
      requisition: null
    }
  },

  mounted () {
    this.loadCall()
  },

  computed: {
    call () {
      return this.$store.state.attendanceModule.callDetails?.[this.callId] || null
    }
  },

  methods: {
    directionDesc (direction) {
      if (direction === 'AUTO') return 'Ativa Automática'
      if (direction === 'OUT') return 'Ativa Manual'
      if (direction === 'IN') return 'Receptiva'
      return ''
    },

    isValidParamsToLoadCall () {
      const vue = this
      if (!vue.phone) return false
      if (!vue.createdAt) return false
      if (!vue.direction) return false

      return !vue.phone?.includes('*99*')
    },

    async loadCall () {
      if (!this.isValidParamsToLoadCall()) {
        this.isLoading = false
      }

      try {
        await this.$store.dispatch('attendanceModule/loadCall', {
          callId: this.callId,
          params: {
            agent: Number(this.agentId),
            queue: this.queueId,
            phone: this.phone,
            created: this.createdAt,
            direction: this.direction
          }
        })
      } catch (err) {
        console.log('Error loading call details:', err)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
